"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getDevice = exports.wait = exports.notNullish = exports.chainIdToHex = exports.toHexString = void 0;
var bowser_1 = __importDefault(require("bowser"));
var toHexString = function (val) {
    return typeof val === 'number' ? "0x".concat(val.toString(16)) : val;
};
exports.toHexString = toHexString;
function chainIdToHex(chains) {
    return chains.map(function (_a) {
        var id = _a.id, rest = __rest(_a, ["id"]);
        var hexId = (0, exports.toHexString)(id);
        return __assign({ id: hexId }, rest);
    });
}
exports.chainIdToHex = chainIdToHex;
var notNullish = function (value) {
    return value != null;
};
exports.notNullish = notNullish;
var wait = function (time) {
    return new Promise(function (resolve) { return setTimeout(resolve, time); });
};
exports.wait = wait;
function getDevice() {
    if (typeof window !== 'undefined') {
        var parsed = bowser_1["default"].getParser(window.navigator.userAgent);
        var os = parsed.getOS();
        var browser = parsed.getBrowser();
        var type = parsed.getPlatform().type;
        return {
            type: type,
            os: os,
            browser: browser
        };
    }
    else {
        return {
            type: null,
            os: null,
            browser: null
        };
    }
}
exports.getDevice = getDevice;
